import './index.css'
import React from 'react';
import Autocomplete from '../common/Autocomplete';
import InputLabel from '../common/InputLabel';


export default function BasicData(props: any) {
  const action = props.action
  const handleChange = props.handleChange
  const handleSelection = props.handleSelection
  const elementForm = props.elementForm
  const elementTypesList = props.elementTypesList
  const sitesList = props.sitesList

  return (
    <React.Fragment>
      <div className='element-form-section'>
        <div className='element-form-section-title'>
          <p>DATOS BÁSICOS</p>
        </div>

        <div className='element-form-section-item'>
          <InputLabel
            label='Nombre'
            placeholder="Nombre"
            disabled={action === 'view'}
            name='name'
            value={elementForm.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className='element-form-section-item'>
          <Autocomplete
            label='Tipo'
            placeholder='Tipo'
            disabled={action === 'view'}
            options={elementTypesList}
            value={elementForm.element_type}
            name='element_type'
            handleSelection={handleSelection}
            required
          />
        </div>

        <div className='element-form-section-item'>
          <Autocomplete
            label='Sitio'
            placeholder='Sitio'
            disabled={action === 'view'}
            options={sitesList}
            value={elementForm.site}
            name='site'
            handleSelection={handleSelection}
            required
          />
        </div>
      </div>
    </React.Fragment>
  );
}
